/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ssc_Secure_FulfillmentInputs */

const en_ssc_secure_fulfillment = /** @type {(inputs: Ssc_Secure_FulfillmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC Secure Fulfillment`)
};

const es_ssc_secure_fulfillment = /** @type {(inputs: Ssc_Secure_FulfillmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cumplimiento Seguro de SSC`)
};

const fr_ssc_secure_fulfillment = /** @type {(inputs: Ssc_Secure_FulfillmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exécution sécurisée SSC`)
};

const de_ssc_secure_fulfillment = /** @type {(inputs: Ssc_Secure_FulfillmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichere SSC-Erfüllung`)
};

const id_ssc_secure_fulfillment = /** @type {(inputs: Ssc_Secure_FulfillmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemenuhan Aman SSC`)
};

/** @type {(inputs: Ssc_Secure_FulfillmentInputs) => LocalizedString} */
const ja_ssc_secure_fulfillment = en_ssc_secure_fulfillment;

/** @type {(inputs: Ssc_Secure_FulfillmentInputs) => LocalizedString} */
const zh_ssc_secure_fulfillment = en_ssc_secure_fulfillment;

/** @type {(inputs: Ssc_Secure_FulfillmentInputs) => LocalizedString} */
const ar_ssc_secure_fulfillment = en_ssc_secure_fulfillment;

/** @type {(inputs: Ssc_Secure_FulfillmentInputs) => LocalizedString} */
const it_ssc_secure_fulfillment = en_ssc_secure_fulfillment;

/** @type {(inputs: Ssc_Secure_FulfillmentInputs) => LocalizedString} */
const ru_ssc_secure_fulfillment = en_ssc_secure_fulfillment;

/** @type {(inputs: Ssc_Secure_FulfillmentInputs) => LocalizedString} */
const pt_ssc_secure_fulfillment = en_ssc_secure_fulfillment;

/** @type {(inputs: Ssc_Secure_FulfillmentInputs) => LocalizedString} */
const ko_ssc_secure_fulfillment = en_ssc_secure_fulfillment;

/**
* | output |
* | --- |
* | "SSC Secure Fulfillment" |
*
* @param {Ssc_Secure_FulfillmentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ssc_secure_fulfillment = /** @type {((inputs?: Ssc_Secure_FulfillmentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ssc_Secure_FulfillmentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ssc_secure_fulfillment(inputs)
	if (locale === "es") return es_ssc_secure_fulfillment(inputs)
	if (locale === "fr") return fr_ssc_secure_fulfillment(inputs)
	if (locale === "de") return de_ssc_secure_fulfillment(inputs)
	if (locale === "ja") return ja_ssc_secure_fulfillment(inputs)
	if (locale === "zh") return zh_ssc_secure_fulfillment(inputs)
	if (locale === "ar") return ar_ssc_secure_fulfillment(inputs)
	if (locale === "id") return id_ssc_secure_fulfillment(inputs)
	if (locale === "it") return it_ssc_secure_fulfillment(inputs)
	if (locale === "ru") return ru_ssc_secure_fulfillment(inputs)
	if (locale === "pt") return pt_ssc_secure_fulfillment(inputs)
	return ko_ssc_secure_fulfillment(inputs)
});